"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationImage = exports.NotificationInfoContent = exports.NotificationInfo = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_regular_basis_fdr_image_1 = require("@hotelplan/fdr.regular.basis.fdr-image");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
exports.NotificationInfo = styled_components_1.default.div(({ theme }) => theme.notifications.notificationInfo || {});
exports.NotificationInfoContent = styled_components_1.default.div(({ theme }) => theme.notifications.notificationInfoContent || {});
exports.NotificationImage = (0, styled_components_1.default)(fdr_regular_basis_fdr_image_1.FdrImage)((0, util_theme_sxc_1.sx2CssThemeFn)({
    mx: 2,
}));
//# sourceMappingURL=fdr-information-notification.styles.js.map